import { Link } from 'react-router-dom';
import { useState } from 'react';

const benefits = [
  {
    icon: 'ri-calendar-schedule-line',
    title: '自由なスケジュール',
    description: '自分のペースで働けます。空いた時間を有効活用して収入を得ましょう。',
  },
  {
    icon: 'ri-money-euro-circle-line',
    title: '料金は自分で設定',
    description: '自分のサービスに合った料金を自由に設定できます。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安心の保険・サポート',
    description: 'プラットフォームが提供する保険とサポート体制で安心して働けます。',
  },
  {
    icon: 'ri-heart-line',
    title: '大好きなペットと一緒',
    description: '動物が好きなら最高の仕事。毎日ペットと過ごせる喜びがあります。',
  },
  {
    icon: 'ri-community-line',
    title: '日本人コミュニティ',
    description: '海外在住の日本人シッターネットワークで繋がり、情報交換も。',
  },
  {
    icon: 'ri-star-line',
    title: '評価で信頼を積む',
    description: 'レビューと評価で実績を積み上げ、より多くの依頼を受けましょう。',
  },
];

const steps = [
  { step: '01', title: '登録する', description: 'プロフィールと提供サービスを登録' },
  { step: '02', title: '審査を受ける', description: '本人確認と簡単な審査を通過' },
  { step: '03', title: '依頼を受ける', description: 'ペットオーナーからの依頼を受付' },
  { step: '04', title: '収入を得る', description: 'サービス完了後に安全に報酬を受取' },
];

export default function SittersPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#EEF4F7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-[#81D8D0] shadow-sm">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-between h-24 sm:h-28">
            <Link to="/" className="flex items-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="w-40 h-40 sm:w-48 sm:h-48 object-contain brightness-0"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8 lg:gap-10">
              <Link to="/about" className="relative text-sm font-semibold text-white/90 hover:text-white transition-colors tracking-wide whitespace-nowrap group">
                PawBridgeについて
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/sitters" className="relative text-sm font-semibold text-white transition-colors tracking-wide whitespace-nowrap group">
                シッターを探す
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-white rounded-full"></span>
              </Link>
              <Link to="/sitter-registration" className="relative text-sm font-semibold text-white/90 hover:text-white transition-colors tracking-wide whitespace-nowrap group">
                シッター登録
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link
                to="/login"
                className="px-6 py-2.5 bg-white text-[#81D8D0] text-sm font-bold rounded-full hover:bg-[#1B2A4A] hover:text-white transition-all shadow-md hover:shadow-lg whitespace-nowrap"
              >
                ログイン
              </Link>
            </div>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
          {mobileMenuOpen && (
            <div className="md:hidden pb-4 space-y-1 animate-fadeIn border-t border-white/20 pt-3">
              <Link to="/about" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white hover:bg-white/10 rounded-lg transition-colors">PawBridgeについて</Link>
              <Link to="/sitters" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white hover:bg-white/10 rounded-lg transition-colors">シッターを探す</Link>
              <Link to="/sitter-registration" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white hover:bg-white/10 rounded-lg transition-colors">シッター登録</Link>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white hover:bg-white/10 rounded-lg transition-colors">ログイン</Link>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <div className="relative pt-24 sm:pt-28 overflow-hidden">
        <div
          className="relative w-full min-h-[520px] flex items-center justify-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/a979fb47ea381cdecdc90e9136a5bd4f.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A]/75 via-[#1B2A4A]/50 to-transparent"></div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 py-20">
            <div className="max-w-xl">
              <span className="inline-block px-4 py-1.5 bg-[#81D8D0]/20 border border-[#81D8D0]/40 text-[#81D8D0] text-xs font-bold uppercase tracking-widest rounded-full mb-5">
                シッター募集中
              </span>
              <h1 className="text-4xl sm:text-5xl font-bold text-white leading-tight mb-5">
                あなたの愛情を<br />
                <span className="text-[#81D8D0]">仕事</span>にしませんか？
              </h1>
              <p className="text-white/80 text-base sm:text-lg leading-relaxed mb-8">
                PawBridgeでは、海外在住の日本人シッターを積極的に募集しています。大好きなペットと過ごしながら、自分のペースで収入を得ましょう。
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/sitter-registration"
                  className="px-8 py-3.5 bg-[#81D8D0] text-white font-bold rounded-full hover:bg-white hover:text-[#81D8D0] transition-all shadow-lg whitespace-nowrap"
                >
                  今すぐシッター登録
                </Link>
                <a
                  href="#how-it-works"
                  className="px-8 py-3.5 bg-white/10 border border-white/30 text-white font-semibold rounded-full hover:bg-white/20 transition-all whitespace-nowrap"
                >
                  詳しく見る
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="bg-white border-b border-[#D4E8EC]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 grid grid-cols-3 divide-x divide-[#EEF4F7]">
          {[
            { value: '準備中', label: '登録シッター数' },
            { value: 'オランダ・ドイツ', label: '対応エリア（拡大中）' },
            { value: '100%', label: '日本語対応' },
          ].map((stat) => (
            <div key={stat.label} className="text-center px-6">
              <div className="text-xl font-bold text-[#1B2A4A]">{stat.value}</div>
              <div className="text-xs text-[#1B2A4A]/50 mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits Section */}
      <div className="py-20 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl font-bold text-[#1B2A4A] mb-3">PawBridgeシッターの魅力</h2>
            <p className="text-[#1B2A4A]/50 text-sm max-w-md mx-auto">
              自分のライフスタイルに合わせて、ペットと過ごす時間を収入に変えましょう。
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((b) => (
              <div
                key={b.title}
                className="bg-white rounded-2xl p-6 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4F0ED] rounded-xl mb-4">
                  <i className={`${b.icon} text-2xl text-[#81D8D0]`}></i>
                </div>
                <h3 className="text-base font-bold text-[#1B2A4A] mb-2">{b.title}</h3>
                <p className="text-sm text-[#1B2A4A]/60 leading-relaxed">{b.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div id="how-it-works" className="py-20 px-6 lg:px-10 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl font-bold text-[#1B2A4A] mb-3">シッター登録の流れ</h2>
            <p className="text-[#1B2A4A]/50 text-sm">簡単4ステップで始められます</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((s, i) => (
              <div key={s.step} className="relative flex flex-col items-center text-center">
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-[60%] w-full h-px border-t-2 border-dashed border-[#D4E8EC] z-0"></div>
                )}
                <div className="relative z-10 w-16 h-16 flex items-center justify-center bg-[#81D8D0] text-white text-xl font-bold rounded-full mb-4 shadow-md">
                  {s.step}
                </div>
                <h3 className="text-base font-bold text-[#1B2A4A] mb-1">{s.title}</h3>
                <p className="text-sm text-[#1B2A4A]/55 leading-relaxed">{s.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Eligibility Section */}
      <div className="py-20 px-6 lg:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-[#1B2A4A] to-[#2C4A7A] rounded-3xl p-10 sm:p-14 flex flex-col lg:flex-row items-center gap-10">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 bg-[#81D8D0]/20 text-[#81D8D0] text-xs font-bold rounded-full mb-4 uppercase tracking-wider">
                応募条件
              </span>
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                こんな方を歓迎します
              </h2>
              <ul className="space-y-3 mb-8">
                {[
                  '海外在住の日本人',
                  'ペットが大好きな方',
                  'オランダまたはドイツ在住',
                  '責任感があり丁寧に対応できる方',
                  '経験不問（ペットへの愛情が一番大切）',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-3 text-white/80 text-sm">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-[#81D8D0] text-lg"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
              <Link
                to="/sitter-registration"
                className="inline-block px-8 py-3.5 bg-[#81D8D0] text-white font-bold rounded-full hover:bg-white hover:text-[#1B2A4A] transition-all whitespace-nowrap"
              >
                無料で登録する
              </Link>
            </div>
            <div className="w-full lg:w-80 h-64 lg:h-80 rounded-2xl overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=smiling-japanese-woman-hugging-cute-dog-in-cozy-home-warm-natural-light-happy-pet-sitter-lifestyle-clean-simple-background-inviting-atmosphere&width=400&height=400&seq=sitters-cta&orientation=squarish"
                alt="シッター"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Teaser */}
      <div className="py-16 px-6 lg:px-10 bg-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-[#1B2A4A] mb-3">気になることがありましたら</h2>
          <p className="text-sm text-[#1B2A4A]/55 mb-8">
            よくある質問はFAQをご覧いただくか、お気軽にお問い合わせください。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/#faq"
              className="px-6 py-3 border border-[#D4E8EC] text-[#1B2A4A] text-sm font-semibold rounded-full hover:bg-[#EEF4F7] transition-colors whitespace-nowrap cursor-pointer"
            >
              FAQを見る
            </Link>
            <Link
              to="/contact"
              className="px-6 py-3 bg-[#EEF4F7] text-[#1B2A4A] text-sm font-semibold rounded-full hover:bg-[#D4F0ED] transition-colors whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#81D8D0] text-white pt-12 sm:pt-16 md:pt-20 pb-8 sm:pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-10 md:gap-12 mb-8 sm:mb-10 md:mb-12">
            <div>
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="w-40 h-40 sm:w-48 sm:h-48 object-contain mb-4 sm:mb-5 brightness-0"
              />
              <p className="text-lg sm:text-xl font-bold text-white leading-relaxed">
                海外在住日本人の為の<br />ペットシッターコミュニティ
              </p>
            </div>

            <div>
              <h4 className="text-base font-semibold uppercase mb-4 sm:mb-6">サービス</h4>
              <ul className="space-y-3 sm:space-y-4">
                <li><Link to="/sitters" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">シッター検索<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
                <li><Link to="/sitter-registration" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">シッター登録<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
                <li><Link to="/booking" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">料金<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-base font-semibold uppercase mb-4 sm:mb-6">会社情報</h4>
              <ul className="space-y-3 sm:space-y-4">
                <li><Link to="/about" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">PawBridgeについて<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
                <li><Link to="/contact" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">お問い合わせ<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
                <li><Link to="/terms" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">PawBridge 利用規約<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
                <li><Link to="/sitter-terms" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">PawBridge シッター利用規約<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
                <li><Link to="/guarantee" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">PawBridge 安心保証規約<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
                <li><Link to="/privacy" className="relative text-base text-white/80 hover:text-white transition-colors group inline-block">プライバシーポリシー<span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span></Link></li>
              </ul>
            </div>
          </div>

          <div className="pt-6 sm:pt-8 border-t border-white/30 text-center">
            <p className="text-sm text-white/70">© 2025 PawBridge. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
